module.exports = __webpack_public_path__ + "static/media/not-rated.d789b158.svg";